import { render, staticRenderFns } from "./SlidePage3.vue?vue&type=template&id=f7a280cc&scoped=true&"
import script from "./SlidePage3.vue?vue&type=script&lang=js&"
export * from "./SlidePage3.vue?vue&type=script&lang=js&"
import style0 from "./SlidePage3.vue?vue&type=style&index=0&id=f7a280cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a280cc",
  null
  
)

export default component.exports